<cl-ui-configuration-header
  [title]="title"
  [description]="description"
  [checked]="checked"
  [showSwitch]="showSwitch"
  (changed)="handleSwitchChange()"
></cl-ui-configuration-header>
